<div class="grid grid-1">
    <footer class="col-span-1">
        <div class="mx-auto max-w-7xl px-4 py-2 text-center text-xs sm:text-sm">
            Copyright © {{ currentYear }}&nbsp;
            <span class="font-medium">Publio.ai</span>
            &nbsp;|&nbsp; Powered by&nbsp;
            <span class="font-medium">Brainfood SA</span>
        </div>
    </footer>
</div>